

const LandingLayout = ({children}) => {
  return children
}

export default LandingLayout
